"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckDryvanTeam = function SvgIconTruckDryvanTeam(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck dryvan team icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Dryvan Team Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.267 24h5.752l-2.53-3.308h-3.222zm1.288 8.604c1.067 0 1.933-.892 1.933-1.985 0-1.1-.866-1.985-1.933-1.985-1.07 0-1.933.886-1.933 1.985 0 1.093.865 1.985 1.933 1.985zm-20.424-9.908c.822-1.338 1.306-2.911 1.306-4.463 0-.663-.094-1.305-.268-1.912a4.26 4.26 0 012.46-.779 4.29 4.29 0 014.284 4.285c0 2.425-1.91 5.356-4.285 5.356-1.446 0-2.72-1.089-3.496-2.489zm3.983 9.986v-3.374a4.78 4.78 0 00-.715-2.516l.23-.002c1.969 0 3.493.36 4.425.662a2.126 2.126 0 011.466 2.033v2.661a.535.535 0 01-.535.536zm2.023-19.27h9.88v13.35h1.348v-8.057h5.77L44 24v6.619h-2.58c0 2.19-1.73 3.969-3.864 3.969-2.137 0-3.866-1.779-3.866-3.97h-5.047V29.59c0-1.92-1.178-3.619-2.931-4.21a15.21 15.21 0 00-.773-.237c1.291-1.492 2.096-3.566 2.096-5.6 0-2.75-1.608-5.115-3.898-6.13zm-6.818 4.82c0 2.669-2.15 5.892-4.82 5.892-2.67 0-4.82-3.223-4.82-5.891a4.826 4.826 0 014.82-4.821 4.826 4.826 0 014.82 4.82zM4.535 33.766A.536.536 0 014 33.23v-3.922c0-1.131.72-2.146 1.79-2.527 1.345-.48 3.428-1.05 5.708-1.05 2.281 0 4.364.572 5.71 1.05a2.69 2.69 0 011.789 2.527v3.922c0 .296-.24.535-.536.535H4.536z"
  }));
};

var _default = SvgIconTruckDryvanTeam;
exports.default = _default;